import React from 'react'

const BreadcrumbsHome = props => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.10611 13.8478V11.8033C6.1061 11.2833 6.53005 10.8607 7.05531 10.8572H8.97936C9.50713 10.8572 9.93497 11.2808 9.93497 11.8033V11.8033V13.8541C9.93485 14.2956 10.2908 14.6565 10.7367 14.6668H12.0194C13.2981 14.6668 14.3346 13.6406 14.3346 12.3747V12.3747V6.55872C14.3278 6.06071 14.0916 5.59306 13.6933 5.28885L9.30645 1.79036C8.53792 1.18121 7.44544 1.18121 6.67691 1.79036L2.30932 5.2952C1.90947 5.59818 1.67289 6.06661 1.66797 6.56507V12.3747C1.66797 13.6406 2.70455 14.6668 3.98324 14.6668H5.26594C5.72287 14.6668 6.09328 14.3001 6.09328 13.8478V13.8478"
      stroke="#004360"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default BreadcrumbsHome
